import { useEffect, useState } from "react";

const SingleOutputTextAreaView = ({
  onGenerate,
  countText = "Count",
  strings,
  toolStrings,
  defaultText = "",
  optionsView: OptionsView,
  options: initOptions,
}) => {
  const [text, setText] = useState(defaultText);
  const [outputText, setOutputText] = useState(defaultText);
  const [options, setOptions] = useState(initOptions || {});

  useEffect(() => {
    setOutputText(onGenerate(text, options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, options]);

  return (
    <div className="container-fluid d-flex flex-column">
      <div className="form-group p-1">
        <label htmlFor="countLabel">{countText}</label>
        <input
          type="text"
          className="form-control input-readonly"
          id="countLabel"
          placeholder="Value will show up here"
          readOnly
          value={outputText}
        />
      </div>
      {OptionsView && (
        <OptionsView
          strings={strings}
          toolStrings={toolStrings}
          options={options}
          onChange={(opt) => setOptions(opt)}
        />
      )}

      <div className="form-group flex-grow-1 p-2">
        <textarea
          className="form-control textarea-readonly flex-grow-1 h-100 w-100"
          onChange={({ target: { value } }) => setText(value)}
          value={text}
        ></textarea>
      </div>
    </div>
  );
};

export default SingleOutputTextAreaView;
